import { render } from "./UserProfileView.vue?vue&type=template&id=00a862d6&scoped=true"
import script from "./UserProfileView.vue?vue&type=script&lang=js"
export * from "./UserProfileView.vue?vue&type=script&lang=js"

import "./UserProfileView.vue?vue&type=style&index=0&id=00a862d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a862d6"]])

export default __exports__